const GetMarketIntelDetailReducer = (state = { type: 'LOADING_MARKET_INTEL_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_MARKET_INTEL_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}
const GetMarketIntelInHouseDetailReducer = (state = { type: 'LOADING_MARKET_INTEL_INHOUSE_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_MARKET_INTEL_INHOUSE_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetSmartCubeCategoryReducer = (state = { type: 'LOADING_SMARTCUBE_CATEGORY_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SMARTCUBE_CATEGORY_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetMarketIntelDetailReducer,
    GetMarketIntelInHouseDetailReducer,
    GetSmartCubeCategoryReducer
}